import { SubscriptionPlan } from '../utils/bootstrapData';
import useBootstrapData from './useBootstrapData';

export default function useSubscriptionPlan(): SubscriptionPlan | undefined {
  const bootstrapData = useBootstrapData();
  return bootstrapData?.subscription_plan;
}
